package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.BlueBackground
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp

@Composable
fun DetailsLeftMenuItem(text: String, selected: Boolean, onSelected: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(48.toScaleDp())
            .then(
                if (selected)
                    Modifier
                        .background(BlueBackground)
                        .drawBehind {
                            drawLine(
                                color = BlueApp,
                                strokeWidth = Dp(6f).toPx(),
                                start = Offset(Dp(3f).toPx(), 0f),
                                end = Offset(Dp(3f).toPx(), size.height)
                            )
                        }
                else Modifier)
            .clickableWithPointer { onSelected() },
        contentAlignment = Alignment.Center
    ) {
        DisableSelection {
            Text(
                modifier = Modifier.fillMaxWidth().padding(start = 20.toScaleDp()),
                textAlign = TextAlign.Start,
                text = text,
                color = if (selected) BlueApp else TextColor,
                maxLines = 1,
                fontSize = 16.toScaleSp(),
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}